<template>
  <div id="app">
    <header class="app-header">
      <div class="container">
        <div class="header-content">
          <router-link to="/" class="logo">
            <span class="logo-icon">⚡</span>
            <span class="logo-text">电技95 · 聚会平台</span>
          </router-link>
          <nav class="main-nav">
            <router-link to="/" class="nav-link">首页</router-link>
            <router-link to="/about" class="nav-link">关于</router-link>
          </nav>
          <div class="header-actions">
            <button @click="handleLogout" class="btn-logout">退出</button>
          </div>
        </div>
      </div>
    </header>
    <main class="app-main">
      <router-view />
>
    </main>
    <footer class="app-footer">
      <div class="container">
        <p>中国矿业大学 · 电气技术与自动化 1995级</p>
        <p class="footer-sub">相识三十一年 · 回路终闭合</p>
        <p class="icp-beian">
          <a href="https://beian.miit.gov.cn" target="_blank">沪ICP备2023009132号-1</a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    handleLogout() {
      localStorage.removeItem('dj95_authenticated')
      this.$router.push('/login')
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #F0F4F8;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.app-header {
  background: white;
  box-shadow: 0 2px 4px rgba(0, 91, 175, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: #333;
  font-size: 18px;
  font-weight: 700;
}

.logo-icon {
  font-size: 28px;
}

.logo-text {
  background: linear-gradient(135deg, #005BAF 0%, #003D7A 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.main-nav {
  display: flex;
  gap: 30px;
}

.nav-link {
  text-decoration: none;
  color: #666;
  font-size: 15px;
  font-weight: 500;
  transition: color 0.3s;
  position: relative;
}

.nav-link:hover,
.nav-link.router-link-active {
  color: #005BAF;
}

.nav-link.router-link-active::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  right: 0;
  height: 2px;
  background: #005BAF;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.btn-logout {
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  background: transparent;
  border: 1px solid #005BAF;
  color: #005BAF;
}

.btn-logout:hover {
  background: #005BAF;
  color: white;
}

.app-main {
  flex: 1;
}

.app-footer {
  background: linear-gradient(135deg, #005BAF 0%, #003D7A 100%);
  color: white;
  padding: 30px 0;
  text-align: center;
  margin-top: auto;
}

.app-footer p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  margin: 5px 0;
}

.footer-sub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  font-style: italic;
}

.icp-beian {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 10px;
}

.icp-beian a {
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
}

.icp-beian a:hover {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: underline;
}

@media (max-width: 768px) {
  .header-content {
    flex-wrap: wrap;
    height: auto;
    padding: 15px 0;
    gap: 15px;
  }
  
  .logo-text {
    font-size: 14px;
  }
  
  .main-nav {
    order: 3;
    width: 100%;
    justify-content: center;
    gap: 20px;
  }
  
  .header-actions {
    order: 2;
  }
}
</style>
